import React, { useEffect, useState } from "react"
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material"

import {
  AiFillLock,
  AiFillUnlock,
  AiOutlineMail,
  AiOutlineUser,
} from "react-icons/ai"
import mommylogo from "../../images/login-logo.png"
import baby1 from "../../images/baby1.png"
import baby2 from "../../images/baby3.png"
import baby3 from "../../images/babby3.png"
import baby4 from "../../images/babby4.png"
import googleLogo from "../../images/google-logo.png"
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"
import { useSignupWithGoogleMutation, useUserRegisterMutation } from "../../features/Auth/authApi"
import { useNavigate } from "react-router-dom"
import { MdLocalPhone } from "react-icons/md"
import { yupResolver } from "@hookform/resolvers/yup"
import CircularProgress from "@mui/material/CircularProgress"
import { MdVisibility, MdVisibilityOff } from "react-icons/md"
import { useAppSelector } from "../../app/hooks"
import { toast } from "react-toastify"
import { useAppDispatch } from "../../app/store"
import {
  setLanguage,
  setStepsCount,
  setString,
} from "../../features/Auth/WrapperSlice"
import { onBoardKey } from "../../features/Auth/authSlice"
import { LocalPhone } from "@mui/icons-material"
interface signupProps { }
interface SignUpUser {
  name: string
  email: string
  password: string
  contactNo: string
}

const Signup = ({ }: signupProps) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [userRegister, { isError, error, data }] = useUserRegisterMutation()
  const [handleGoogleLogin, { isLoading: googleLoading }] = useSignupWithGoogleMutation()
  const handleClickShowPassword = () => setShowPassword((show) => !show)
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const schemaResolver = yupResolver(
    yup.object().shape({
      name: yup
        .string()
        .required("Please Enter Name")
        .trim()
        .matches(/^[A-Za-z ]+$/, "Name should only contain alphabets and spaces")
        .min(3, "Name Should Be Of 3-25 Characters Only")
        .max(25, "Name Should Be Of 3-25 Characters Only")
        .test(
          "no-multiple-spaces",
          "Name should not contain extra spaces",
          (value) => (value ? !/\s{2,}/.test(value) : true)
        )
        .test(
          "no-trim-spaces",
          "Name should not start or end with space",
          (value) => (value ? value === value.trim() : true)
        ),
      email: yup
        .string()
        .required("Please Enter An Email")
        .test("Valid-Email", "Please Enter A Valid Email", (value) =>
          emailRegex.test(value),
        ),

      contactNo: yup
        .string()
        .required("Please Enter Phone Number")
        .matches(/^(1\s?)?[2-9]\d{2}[2-9]\d{6}$/, "Please enter a valid Canadian phone number (e.g. 604XXXXXXX)")
        .test(
          "not-all-zeros",
          "Phone number cannot be all zeros",
          (value) => value !== undefined && !/^0+$/.test(value),
        ),
      password: yup
        .string()
        .required("Please Fill In A Password")
        .test(
          "Password-Length",
          "Password Must Be 8 Characters Or More",
          (value: any) => value && (value as any).length >= 8,
        )
        .test(
          "Password-Strength",
          "Include At Least One Uppercase Letter, One Lowercase Letter, One Number, And One Special Character",
          (value) =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&~^])[A-Za-z\d@$!%*#?&~^]{8,}$/.test(
              value || "",
            ),
        ),
    }),
  )

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SignUpUser>({
    resolver: schemaResolver,
  })

  const onSubmit = (values: any) => {
    dispatch(setString({}))
    dispatch(setStepsCount(""))
    dispatch(setLanguage(""))
    const payload = {
      name: values.name,
      region: values.region,
      email: values.email,
      password: values.password,
      contactNo: values.contactNo,
    }

    userRegister(payload)
    setLoading(true)
  }

  useEffect(() => {
    if (data?.message) {
      setLoading(false)
      toast.success(data?.message, { autoClose: 1000 })
      dispatch(onBoardKey("onboardingroute" as any))
      navigate("/provider-onboarding")
    } else {
      setLoading(false)
      toast.error((error as any)?.data?.message, { autoClose: 1000 })
    }
  }, [data, error])

  return (
    <>
      <Grid container justifyContent="center">
        <Grid
          item
          lg={6}
          className="d-none d-lg-block"
          display="flex"
          alignItems="center"
        >
          <Box className="box-wrapper">
            <Typography
              sx={{
                textAlign: "center",
                color: " #858585",
                fontFamily: "Montserrat",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
              }}
            >
              Welcome To
            </Typography>
            <Typography textAlign="center">
              <img src={mommylogo} width="300" height="auto" />
            </Typography>
            <Box className="Imgbox" display="flex" flexWrap="wrap" gap={2}>
              <Box>
                <img src={baby1} />
              </Box>
              <Box mt={5}>
                <img src={baby2} />
              </Box>

              <Box>
                <img src={baby3} />
              </Box>

              <Box mt={5}>
                <img src={baby4} />
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid item lg={6}>
          <Box className="Loginform">
            <Typography
              variant="h4"
              mt={5}
              fontFamily="Montserrat"
              fontSize={22}
              fontWeight="600"
              color="pink.main"
              textAlign="center"
            >
              Provider's Sign Up
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-name"
                  sx={{
                    color: "white",
                    "&.Mui-focused": {
                      color: "pink.main",
                    },
                  }}>Name</InputLabel>
                <Controller
                  name="name"
                  control={control}
                  render={({ field }: any) => (
                    <OutlinedInput
                      id="outlined-adornment-name"
                      {...field}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton edge="end">
                            <AiOutlineUser />
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Name"
                      size="medium"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(55, 50, 50, 0.2)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                          borderWidth: 2,
                        },
                      }}
                    />
                  )}
                />
                {errors.name && (
                  <Typography variant="body2" color="error">
                    {errors.name.message}
                  </Typography>
                )}
              </FormControl>
              <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-email"
                  sx={{
                    color: "white",
                    "&.Mui-focused": {
                      color: "pink.main",
                    },
                  }}>
                  Email
                </InputLabel>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }: any) => (
                    <OutlinedInput
                      {...field}
                      type="email"
                      id="outlined-adornment-email"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton edge="end">
                            <AiOutlineMail />
                          </IconButton>
                        </InputAdornment>
                      }
                      label="email"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(55, 50, 50, 0.2)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                          borderWidth: 2,
                        },
                      }}
                    />
                  )}
                />
                {errors.email && (
                  <Typography variant="body2" color="error">
                    {errors.email.message}
                  </Typography>
                )}
              </FormControl>

              <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-name"
                  sx={{
                    color: "white",
                    "&.Mui-focused": {
                      color: "pink.main",
                    },
                  }}>
                  Phone Number
                </InputLabel>
                <Controller
                  name="contactNo"
                  control={control}
                  render={({ field }: any) => (
                    <OutlinedInput
                      type="text"
                      inputMode="numeric"
                      {...field}
                      onKeyPress={(event) => {
                        const keyCode = event.keyCode || event.which
                        const keyValue = String.fromCharCode(keyCode)
                        const numericRegex = /^[0-9]+$/

                        if (!numericRegex.test(keyValue)) {
                          event.preventDefault()
                        }
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton edge="end">
                            <LocalPhone />
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Phone Number"
                      size="medium"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(55, 50, 50, 0.2)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                          borderWidth: 2,
                        },
                      }}
                    />
                  )}
                />
                {errors.contactNo && (
                  <Typography variant="body2" color="error">
                    {errors.contactNo.message}
                  </Typography>
                )}
              </FormControl>

              {/* <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>

                <Controller
                  name="password"
                  control={control}
                  render={({ field }: any) => (
                    <OutlinedInput
                      {...field}
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <AiFillUnlock /> : <AiFillLock />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="password"
                    />
                  )}
                />
                {errors.password && (
                  <Typography variant="body2" color="error">
                    {errors.password.message}
                  </Typography>
                )}
              </FormControl> */}
              <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-password"
                  sx={{
                    color: "white",
                    "&.Mui-focused": {
                      color: "pink.main",
                    },
                  }}>
                  Password
                </InputLabel>

                <Controller
                  name="password"
                  control={control}
                  render={({ field }: any) => (
                    <OutlinedInput
                      {...field}
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? (
                              <MdVisibility />
                            ) : (
                              <MdVisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="password"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(55, 50, 50, 0.2)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                          borderWidth: 2,
                        },
                      }}
                    />
                  )}
                />
                {errors.password && (
                  <Typography variant="body2" color="error">
                    {errors.password.message}
                  </Typography>
                )}
              </FormControl>
              <Button
                type="submit"
                size="large"
                variant="contained"
                sx={{ mt: 3, display: "block", cursor: "pointer" }}
                fullWidth
              >
                {loading ? (
                  <Typography fontSize={1}>
                    <CircularProgress
                      style={{ color: "pink", fontSize: 23 }}
                      size={23}
                    />
                  </Typography>
                ) : (
                  "Sign up"
                )}
              </Button>
            </form>
            <Box mt={3}>
              <Typography
                sx={{
                  color: "#7B7B7B",
                  margin: "8px 0 0 13px",
                  textAlign: "center",
                }}
              >
                Already Have An Account?{" "}
                <Typography
                  component="span"
                  sx={{ color: "#181818", cursor: "pointer" }}
                  onClick={() => navigate("/")}
                >
                  Sign In
                </Typography>
              </Typography>
            </Box>

            <button
              onClick={() => handleGoogleLogin().unwrap().then((r) => window.open(r.url, "_self"))}
              disabled={googleLoading}
              className="bg-transparent border-0 rounded-circle shadow-lg p-2 mx-auto mt-4">
              <Box>
                <img src={googleLogo} height={35} />
              </Box>
            </button>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default Signup
